/* TIICHOO landing trust fixes 20260730-cookie-privacy-link-1 */
(function () {
  'use strict';

  var BRAND_PRIVACY_URL = 'https://www.tiichoo.com/pages/privacy-policy';
  var LEGACY_HOST_PATTERN = /cb9dc2\.myshopify\.com\/policies\/privacy-policy/i;

  function isCookieLearnMoreLink(link) {
    var href = link.getAttribute('href') || '';
    var text = (link.textContent || '').trim().toLowerCase();
    if (LEGACY_HOST_PATTERN.test(href)) return true;
    if (!/\/policies\/privacy-policy/i.test(href)) return false;
    return text === 'learn more' || text === 'privacy policy';
  }

  function fixCookiePrivacyLinks(root) {
    var links = (root || document).querySelectorAll('a[href*="privacy-policy"]');
    links.forEach(function (link) {
      if (!isCookieLearnMoreLink(link)) return;
      link.setAttribute('href', BRAND_PRIVACY_URL);
      link.setAttribute('target', '_self');
    });
  }

  function start() {
    fixCookiePrivacyLinks(document);
    if (!window.MutationObserver || !document.documentElement) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        fixCookiePrivacyLinks(mutations[i].target || document);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
